// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38uQ6","notes":"Notes_notes___oocS","note":"Notes_note__2Iz50","markdown":"Notes_markdown__3Y92G"};